var DIVIDER_VARIANT;
(function (DIVIDER_VARIANT) {
    DIVIDER_VARIANT["option"] = "option";
    DIVIDER_VARIANT["solid"] = "solid";
    DIVIDER_VARIANT["solid_light"] = "solid_light";
    DIVIDER_VARIANT["solid_dark"] = "solid_dark";
})(DIVIDER_VARIANT || (DIVIDER_VARIANT = {}));

export { DIVIDER_VARIANT as D };
